import { getFrontendURL } from 'src/utils/url';

export const OptionImage = (props: any) => {
  const { icon, isTest } = props;

  const isIconImg =
    typeof icon === "string" &&
    (icon.indexOf("/") === 0 || icon.indexOf("http") === 0);

  return isIconImg ? (
    <img
      src={getFrontendURL() + '/' + icon}
      className={`not-rounded ${isTest ? "TEST_FEATURE" : ""}`}
      style={{
        height: 25,
        width: 25,
        objectFit: "contain",
      }}
    />
  ) : (
    <i
      style={{
        color: "black",
        fontSize: 22,
        height: 25,
        width: 25,
        textAlign: "center",
      }}
      className={`not-rounded ${icon} ${isTest ? "TEST_FEATURE" : ""}`}
    ></i>
  );
};
